import React, { useContext, useState } from 'react';
import {
  BodyControls,
  BodyDesc,
  BodyBlockBody,
  FormGroup,
  FormGroupLabel,
  BodyBlock,
  BodyBlockDesc,
  ButtonCancel,
  ButtonSubmit
} from '../styles';
import { TStep } from '../index';
import { TError } from 'models';
import { AccountContext } from 'src/components/Accounts';
import renderErrors from '../common/Errors';
import Input from '../components/Input';
import { translate } from '../../../utils';
import BlockHead from '../common/BlockHead';
import { isMFAValid, onChangeMFAInput, TMFAForm } from '../../../utils/MFAHelpers';

interface Props {
  onChangeStep: (step: TStep) => void,
}

export const BodyMFAVerify = ({ onChangeStep }: Props) => {

  const { verifyMfa } = useContext(AccountContext);

  const [form, updateForm] = useState<TMFAForm>({
    code: '',
    errorApi: [],
  });

  const onSubmit = (event: React.FormEvent) => {
    if (event) {
      event.preventDefault();
    }

    const { code, errorApi } = form;

    if (errorApi.length > 0) {
      updateForm({
        ...form,
        errorApi: [],
      });
    }

    if (isMFAValid(code)) {
      verifyMfa(code, onAPIError);
    } else {
      updateForm({
        ...form,
        errorApi: [{ code: '', message: translate({ key: 'sso.mfa.error.code_not_valid' }) }],
      });
    }
  };

  const onAPIError = (err: TError[]) => {
    if (err?.length) {
      onChangeMFAInput('errorApi', err, form, updateForm);
    }
  };

  const renderForm = () => (
    <>
      <BodyBlockDesc>
        <BlockHead title={translate({ key: 'sso.mfa.verify.title' })} />
        <BodyDesc>
          {translate({ key: 'sso.mfa.verify.desc' })}
        </BodyDesc>
      </BodyBlockDesc>
      <BodyBlockBody onSubmit={onSubmit}>
        {form.errorApi?.length ? renderErrors(form.errorApi) : null}
        <FormGroup>
          <FormGroupLabel>{translate({ key: 'sso.mfa.verify.input' })}</FormGroupLabel>
          <Input
            value={form.code}
            minLength={6}
            required={true}
            handleChange={(value) => onChangeMFAInput('code', value, form, updateForm)}
          />
        </FormGroup>
        <BodyControls>
          <ButtonSubmit size="l" type="submit">
            {translate({ key: 'sso.buttons.mfa.verify' })}
          </ButtonSubmit>
          <ButtonCancel size="l" type="reset" onClick={() => onChangeStep('login')}>
            {translate({ key: 'sso.buttons.cancel' })}
          </ButtonCancel>
        </BodyControls>
      </BodyBlockBody>
    </>
  );

  return (
    <BodyBlock>
      {renderForm()}
    </BodyBlock>
  );

};
